import React, { useState, useEffect, useCallback, useContext } from "react"
import StatusIconText from "../../../components/StatusIconText"
import SendEmailIcon from "@mui/icons-material/ForwardToInbox"
import SendToMobileOutlinedIcon from '@mui/icons-material/SendToMobileOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import { ErrorPage } from "../../AuxiliarPages/ErrorPage/ErrorPage"
import { LoadingPage } from "../../AuxiliarPages/LoadingPage/LoadingPage"
import { CircularProgress, Dialog as MuiDialog, Tooltip } from "@mui/material";
import NotificationDialog from "./NotificationDialog/NotificationDialog"
import { CancelEnvelopeDecisionDialog } from "./CancelEnvelopeDecisionDialog/CancelEnvelopeDecisionDialog"
import { CancelEnvelopeErrorDialog } from "./CancelEnvelopeErrorDialog/CancelEnvelopeErrorDialog"
import { ReportErrorDialog } from "./ReportErrorDialog/ReportErrorDialog"
import { DeleteDocumentErrorDialog } from "./DeleteDocumentErrorDialog/DeleteDocumentErrorDialog"
import { ZipErrorDialog } from "./ZipErrorDialog/ZipErrorDialog"
import { DataField } from "../../../components/DataField"
import BaseButton from "../../../components/BaseButton"
import DownloadIcon from '@mui/icons-material/Download'
import FolderZipIcon from '@mui/icons-material/FolderZip';
import LoadingIcon from "../../../assets/images/loading.svg"
import { DatetimeBlock } from "../../../components/DatetimeBlock"
import AuthContext from "../../../context/auth-context"
import ErrorBoundary from "../../AuxiliarPages/ErrorBoundary/ErrorBoundary"
import EditNoteIcon from '@mui/icons-material/EditNote'
import SignerDataDialog from "./SignerDataDialog/SignerDataDialog"
import { BaseAvatar } from "../../../components/BaseAvatar"
import { formatBirthdateToFront } from "../../../utils/utils"
import FindInPageIcon from '@mui/icons-material/FindInPage';
import PDFContent from "../../../utils/PDFContent/PDFContent";
// import { Dialog, Flex, IconButton, Tooltip } from "@radix-ui/themes";
// import { Pencil1Icon } from "@radix-ui/react-icons";
// import SignerChangeDialog from './SignerChangeDialog';
import LegacySignerChangeDialog from "./LegacySignerChangeDialog";
import { Dialog } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid'
import { SubmitEnvelopeErrorDialog } from "./SubmitEnvelopeErrorDialog/SubmitEnvelopeErrorDialog"
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import * as S from "../styles"
import { useDropzone } from 'react-dropzone';
import { TrashIcon } from '@radix-ui/react-icons';
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SignerAnalysisDataDialog from "./SignerAnalysisDataDialog/SignerAnalysisDataDialog"
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import SignerCreationDialog from "./SignerCreationDialog";
import DeleteIcon from '@mui/icons-material/Delete';
import { SignerRemoveDecisionDialog } from "./SignerRemoveDecisionDialog/SignerRemoveDecisionDialog";
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import SignerNotificationsTimeLineDialog from "./SignerNotificationsTimeLineDialog/SignerNotificationsTimeLineDialog"

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '12px',
        },
      },
    },
  },
});

export const EnvelopePage = (props) => {

    const translateSignatureRole = (enumerator) => {
        switch (enumerator) {
            case "signer":
                return "Assinante"
            case "party":
                return "Parte"
            case "witness":
                return "Testemunha"
            case "contractor":
                return "Contratante"
            case "contracted":
                return "Contratado"
            case "transferor":
                return "Cedente"
            case "transferee":
                return "Cessionário"
            case "manager":
                return "Administrador"
            case "attorney":
                return "Procurador"
            case "legal_representative":
                return "Representante legal"
            case "legal_responsible":
                return "Responsável legal"
            case "lawyer":
                return "Advogado"
            case "validator":
                return "Validador"
            case "intervening_party":
                return "Interveniente"
            case "shareholder":
                return "Cotista"
            default:
                return ""
        }
    }

    const envelopeKey = useParams().envelopeKey
    const navigate = useNavigate()
    const userRoles = useContext(AuthContext).user_data.roles

    const userData = useContext(AuthContext).user_data
    const analyst = userData.email || userData.username  

    if (!userRoles.includes("read_envelope")) {
        navigate("/envelope-inbox")
    }

    const [fetchedData, setFetchedData] = useState(undefined)

    const [error, setError] = useState({
        hasError: false,
        statusCode: 200
    })
    const [loading, setLoading] = useState(true)

    const [notificationError, setNotificationError] = useState({
        hasError: false,
        statusCode: 200
    })
    const [notificationLoading, setNotificationLoading] = useState(false)
    const [notificationDialogOpen, setNotificationDialogOpen] = useState(false)

    const [report, setDocumentReport] = useState(undefined)
    const [reportError, setReportError] = useState(false)
    const [reportLoading, setReportLoading] = useState(Array(fetchedData).fill(false));
    const [envelopeLoading, setEnvelopeLoading] = useState(false)
    const [cancelEnvelopeError, setCancelEnvelopeError] = useState(false)
    const [submitEnvelopeError, setSubmitEnvelopeError] = useState(false)

    const [refresh, setRefresh] = useState(false)

    const [editSignerDataDialogOpen, setEditSignerDataDialogOpen] = useState(true)

    const [signerKey, setSignerKey] = useState(undefined)
    const [signerName, setSignerName] = useState(undefined)

    const [dialogValues, setDialogValues] = useState(undefined)
    const [dialogFields, setDialogFields] = useState(undefined)

    const [notificationSignerKey, setNotificationSignerKey] = useState(undefined)

    const [signerChangeDialogOpen, setSignerChangeDialogOpen] = useState('');

    const [signerAnalyzing, setSignerAnalyzing] = useState(undefined)
    const [signerAnalysisDialogOpen, setSignerAnalysisDialogOpen] = useState(false)
    const [envelopeRuleAnalysisLoading, setEnvelopeRuleAnalysisLoading,] = useState(false)

    const [signerNotificationsSelected, setSignerNotificationsSelected] = useState(undefined)
    const [signerNotificationsDialogOpen, setSignerNotificationsDialogOpen] = useState(false)

    const viewSignerAnalysis = (signer) => {
        setSignerAnalyzing(signer)
        setSignerAnalysisDialogOpen(true)
    }

    const viewSignerNotifications = (signer) => {
        setSignerNotificationsSelected(signer)
        setSignerNotificationsDialogOpen(true)
    }

    const fetchEnvelopeData = useCallback(() => {
        const timer = setTimeout(() => {
            axios.get(`/dash/sign/envelope/${envelopeKey}`)
                .then((response) => {
                    setFetchedData(response.data)
                })
                .catch((error) => {
                    if ([404].includes((error.response || {}).status)) {
                        setError({
                            "has_error": true,
                            "status": error.response.status
                        })
                    } else {
                        setError({
                            "has_error": true,
                            "status": 500
                        })
                    }
                })
                .finally(() => {
                    setLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [envelopeKey, refresh])

    useEffect(() => {
        fetchEnvelopeData()
    }, [fetchEnvelopeData])

    const [openSignerCreationDialog, setOpenSignerCreationDialog] = useState(false)
    const [openSignerRemovedDialog, setOpenSignerRemovedDialog] = useState(false)
    const [selectedRemoveSigner, setSelectedRemoveSigner] = useState(undefined)

    const removeSignerFromEnvelopeListDecision = (signer_key) => {
        const activeSigners = (fetchedData.signers || []).filter(signer => !signer.deactivated_on);
        if (activeSigners.length === 1)
            return handleToast('Envelope deve possuir pelo menos um assinante.', 'warning');

        setSelectedRemoveSigner(signer_key)
        setOpenSignerRemovedDialog(true)
    }

    const removeSignerFromEnvelopeList = (signer_key) => {
        setLoading(true)

        if(!fetchedData?.envelope_key){
            setLoading(false)
            return handleToast('Erro ao buscar dados do assinante ativo', 'error')
        }

        if(!userRoles.includes('manage_signers')){
            setLoading(false)
            return handleToast('Erro ao buscar dados do assinante ativo', 'error')
        }

        const timer = setTimeout(() => {
            axios.delete(`/dash/sign/envelope/${fetchedData.envelope_key}/signer/${signer_key}`)
                .then((response) => {
                    setLoading(false)
                    handleToast('Assinante removido da lista', 'success')
                    window.location.reload()
                })
                .catch((error) => {
                    handleToast('Erro ao remover assinante da lista', 'error')
                    console.error(error)
                })
                .finally(() => {
                    setLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }    

    const resendNotification = (signer_key) => {
        let data = {}
        setNotificationSignerKey(signer_key)
        setNotificationLoading(true)
        const timer = setTimeout(() => {
            axios.patch(`/dash/sign/signer/${signer_key}/notify_signer`, data)
                .then((response) => {
                    setNotificationError({
                        hasError: false,
                        statusCode: 200
                    })
                    setNotificationDialogOpen(true)
                })
                .catch((error) => {
                    setNotificationError({
                        hasError: true,
                        statusCode: error.response.status
                    })
                })
                .finally(() => {
                    setNotificationLoading(false)
                    setNotificationDialogOpen(true)
                    fetchEnvelopeData()
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }

    const [zipLoading, setZipIsLoading] = useState(false)
    const [zipError, setZipError] = useState(false)

    const downloadZip = () => {
        setZipIsLoading(true);
        const timer = setTimeout(() => {
            axios.get(`/dash/sign/envelope/${envelopeKey}/zip`)
                .then((response) => {
                    let envelopeZip = response.data
                    const link = document.createElement('a')
                    link.href = envelopeZip.zip_url
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                })
                .catch((error) => {
                    setZipError(true)
                })
                .finally(() => {
                    setZipIsLoading(false);
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }

    const setDocumentReportLoading = (index, value) => {
        const newLoading = [...reportLoading];
        newLoading[index] = value;
        setReportLoading(newLoading);
      };

    const downloadReport = (documentKey, index) => {
        let data = {}
        setDocumentReportLoading(index, true);
        const timer = setTimeout(() => {
            axios.get(`/dash/sign/envelope/${envelopeKey}/document/${documentKey}/report`, data)
                .then((response) => {
                    setDocumentReport(response.data)
                })
                .catch((error) => {                    
                    setReportError(true)
                })
                .finally(() => {
                    setDocumentReportLoading(index, false);
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }

    const [documentRemovalLoading, setDocumentRemovalLoading] = useState(Array(fetchedData?.documents || []).fill(false));
    const [deleteDocumentError, setDeleteDocumentError] = useState(false)
    const handleSetDocumentRemovalLoading = (index, value) => {
        const newLoading = [...documentRemovalLoading];
        newLoading[index] = value;
        setDocumentRemovalLoading(newLoading);
    };

    const deleteDocument = (documentKey, index) => {
        handleSetDocumentRemovalLoading(index, true);
        const timer = setTimeout(() => {
            axios.delete(`/dash/sign/envelope/${envelopeKey}/document/${documentKey}`)
                .then((response) => {
                    handleToast("Arquivo removido com sucesso.", "success")
                    window.location.reload()
                })
                .catch((error) => {
                    console.error(error);
                
                    const status = error?.response?.status;
                    const description = error?.response?.data?.description;
    
                    if (status === 409){
                        if( description === 'Cannot remove documents if there is a signer that already starts signature process') {
                            handleToast("Não é possível remover um arquivo se um assinante já começou o processo de assinatura.", "error");
                        } else if ( description === 'Cannot remove documents if envelope there is not another active document') {
                            handleToast("Um envelope deve possuir pelo menos um documento.", "error");
                        } else if ( description === 'Cannot remove documents from submitted envelope'){
                            handleToast("Não é possível remover arquivo de um envelope já assinado.", "error");
                        } else {
                            handleToast("Erro ao remover arquivo.", "error");
                        }

                    } else {
                        handleToast("Erro ao remover arquivo.", "error");
                    }
                    setDeleteDocumentError(true)
                })
                .finally(() => {
                    handleSetDocumentRemovalLoading(index, false);
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }

    const [canManageDocuments, setCanManageDocuments] = useState(false);
    useEffect(() => {
        if (fetchedData) {
            setDocumentRemovalLoading(Array((fetchedData?.documents?.length || 0)).fill(false))            

            const hasCompletedSigners = (fetchedData.signers || [])
                .some(signer => (signer.completed_signer_signature_step || '').length > 0);

                setCanManageDocuments(!hasCompletedSigners);            
        }
    }, [fetchedData]);

    const [documentKey, setDocumentKey] = useState(undefined);
    const [documentFile, setDocumentFile] = useState(undefined);
    const [openFileDialog, setOpenFileDialog] = useState(false);
    const [documentFileLoading, setDocumentFileLoading] = useState(false);

    const handleCloseFileDialog = () => {
        setOpenFileDialog(false);
        setDocumentFile(null);
        setDocumentKey(null);
    };

    const downloadFile = useCallback(() => {

        setDocumentFileLoading(true)

        const timer = setTimeout(() => {
            axios.get(`/dash/sign/envelope/${envelopeKey}/document/${documentKey}/file`)
                .then((response) => {
                    setDocumentFile(response.data);
                    setOpenFileDialog(true)
                })
                .catch((error) => {
                })
                .finally(() => {
                    setDocumentFileLoading(false)
                });
        }, 500);
        return () => clearTimeout(timer);
    }, [envelopeKey, documentKey]);

    useEffect(() => {
        if (documentKey) {
            downloadFile();
        }
    }, [documentKey, downloadFile]);

    const handleDocumentKey = (documentKey) => {
        setDocumentKey(documentKey);
    };

    const [cancelDialogOpen, setCancelDialogOpen] = useState(false)

    const cancelEnvelope = async (envelopeKey) => {
        const submissionData = {
            "status": "canceled"
        }
        setEnvelopeLoading(true)
        const timer = setTimeout(() => {
            axios.patch(`/dash/sign/envelope/${envelopeKey}`, submissionData)
                .then((response) => {
                    setCancelDialogOpen(false)
                    window.location.reload()
                })
                .catch((error) => {
                    setCancelEnvelopeError(true)
                    setCancelDialogOpen(false)
                })
                .finally(() => {
                    setEnvelopeLoading(false)
                    setLoading(false)
                    setCancelDialogOpen(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }

    const submitEnvelope = async (envelopeKey) => {
        const submissionData = {
            "status": "submitted"
        }
        setEnvelopeLoading(true)
        const timer = setTimeout(() => {
            axios.patch(`/dash/sign/envelope/${envelopeKey}`, submissionData)
                .then((response) => {
                    window.location.reload()
                })
                .catch((error) => {
                    setSubmitEnvelopeError(true)
                })
                .finally(() => {
                    setEnvelopeLoading(false)
                    setLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }
    
    const copySignerSignatureUrl = (signer_key) => {
        const signer = fetchedData.signers.filter((signer) => (signer.signer_key === signer_key))[0]
        const url = signer.signature_url

        const input = document.createElement('input')
        input.setAttribute('value', url)
        document.body.appendChild(input)

        input.select()
        document.execCommand('copy')

        document.body.removeChild(input)
    }

    useEffect(() => {
        if (report) {
            const link = document.createElement('a')
            link.href = report.document_report_url
            link.click()
        }
    }, [report])

    const isNotUndefined = (value) => {
        if (value) return true
        else return false
    }

    const editSignerDataHandler = (signer_key) => {
        setSignerKey(signer_key)
        const signer = fetchedData.signers.filter((signer) => (signer.signer_key === signer_key))[0]
        setSignerName(signer.name)
        setDialogFields({
            phone: isNotUndefined(signer.phone),
            email: isNotUndefined(signer.email)
        })

        let values = {}
        if (isNotUndefined(signer.phone)) {
            const areaCode = signer.phone.area_code
            const number = `${signer.phone.number.slice(0, 5)}-${signer.phone.number.slice(5, 9)}`
            values["phone"] = `$(${areaCode})${number}`
        }
        if (isNotUndefined(signer.email)) {
            values["email"] = signer.email
        }
        setDialogValues(values)

        setEditSignerDataDialogOpen(true)
    }

    const [attachDocumentsLoading, setAttachedDocumentsLoading] = useState(false)
    const [attachedDocuments, setAttachedDocuments] = useState([])
    const resetDocuments = () => {
        setAttachedDocuments([])
        setAttachedDocumentsLoading(false)
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader()
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result)
            }
        })
    }

    const handleAttachDocument = async (event) => {
            const files = event.target.files
            const updatedAttachedDocuments = [...attachedDocuments]
            for (let i = 0; i < files.length; i++) {
                const file = files[i]
                if (file.type !== 'application/pdf') {
                    alert('O documento deve ser em formato PDF')
                    return
                }
                if (file.size > 10000000) {
                    alert('O documento deve ter no máximo 10MB')
                    return
                }
    
                const document_b64 = await convertFileToBase64(file)
                const formmatedDocument = document_b64.replace('data:application/pdf;base64,', '')
                const attachedDocument = {
                    id: uuidv4(),
                    name: file.name,
                    document_b64: formmatedDocument,
                    document_type: 'pdf'
                }
                updatedAttachedDocuments.push(attachedDocument)
            }
            setAttachedDocuments(updatedAttachedDocuments)
        }
    
    const handleRemoveDocument = (documentId) => {
        const updatedAttachedDocuments = attachedDocuments.filter(
            (document) => document.id !== documentId
        )
        setAttachedDocuments(updatedAttachedDocuments)

        const fileInput = document.getElementById('attach-document');
        if (fileInput) {
            fileInput.value = null;
        }
    }

    const handleAttacheDocumentsSubmission = async (envelopeKey) => {
        setAttachedDocumentsLoading(true)
        const timer = setTimeout(async () => {
            try {
                await Promise.all(
                    attachedDocuments.map(async (signatureDocument) => {
                        const submissionData = {
                            id: uuidv4(),
                            name: signatureDocument.name,
                            document_b64: signatureDocument.document_b64,
                            document_type: signatureDocument.document_type,
                        }
                        await axios.post(`/dash/sign/envelope/${envelopeKey}/document`, submissionData);
                    })
                )
                resetDocuments()
                window.location.reload()
            } catch (error) {
                console.error(error)

                const status = error?.response?.status;
                const description = error?.response?.data?.description;
    
                if (status === 409) {
                    if (description === 'Cannot add documents to a submitted envelope') {
                        handleToast("Não é possível adicionar documentos a um envelope já assinado.", "error");
                    } else if (description === 'Cannot add documents if there is a signer that already starts signature process') {
                        handleToast("Não é possível adicionar arquivos se um assinante ja começou a jornada de assinatura. Atualize a página", "error");
                    } else {
                        handleToast("Erro ao adicionar documento ao envelope. Atualize a página", "error");
                    }
                } else {
                    handleToast("Ocorreu um erro ao anexar documentos.", "error");
                }
            } finally {
                setAttachedDocumentsLoading(false)
            }
        }, 500)
    
        return () => {
            clearTimeout(timer);
        }
    }
    const updateEnvelopeRuleAnalysisStatus = (option) => {
        const payload = {
            "status": "waiting_for_rule_analysis",
            "rule_analysis_status": option,
            "analyst": analyst || '',
        }
        setEnvelopeRuleAnalysisLoading(true)

        const timer = setTimeout(() => {
            axios.patch(`/dash/sign/envelope/${envelopeKey}`, payload)
                .then((response) => {
                    window.location.reload()
                })
                .catch((error) => {
                    setCancelEnvelopeError(true)
                })
                .finally(() => {
                    setEnvelopeRuleAnalysisLoading(false)
                    setLoading(false)
                })
        }, 500)
        return () => {
            clearTimeout(timer)
        }
    }

    const handleToast = (message, type) => {
            if (type === "success") {
                toast.success(message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            } else if (type === "error") {
                let errorMessage = message ?? "Ocorreu um erro ao criar o envelope. Tente novamente."
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            } else if (type === 'warning') {
                toast.warning(message, {
                  position: "top-right",
                  autoClose: 2500,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
              })
              }
        }
    
    const stepMapper = {
        "enrich_personal_data": "Dados pessoais",
        "authentication_code": "Código de autentificação",
        "fraud_warning": "Aviso de fraude",
        "terms_of_use": "Termos de uso",
        "term_of_authorization": "Termos de autorização",
        "resume_operation": "Resumo da operação",
        "resume_insurance": "Resumo do seguro da operação",
        "document_display": "Exibição dos documentos",
        "device_scan": "Escaneamento de dispositivo",
        "face_recognition": "Reconhecimento de face",
        "personal_document": "Documento pessoal",
        "additional_document": "Documento adicional",
        "signed": "Assinado",
        "signed_from_api": "Assinado via API",
        "login": "Login"
    }

    function CustomStepper(props) {
        if (props?.signer?.completed_signer_signature_step === 'signed'){
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                    {fetchedData?.signature_settings?.steps?.map((step, index) => (
                    <ThemeProvider key={`${index}-${step.step}`} theme={theme}>
                        <Tooltip key={step.step} title={stepMapper[step.step]}>
                            <Box
                                sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                backgroundColor: '#1976d2',
                                transition: 'background-color 0.3s',
                                cursor: 'default',
                                }}
                            />
                        </Tooltip>
                    </ThemeProvider>
                    ))}
                </Box>
            );
        }
        else {
            if(props?.signer?.completed_signer_signature_step){
                const activeIndex = (fetchedData?.signature_settings?.steps || []).findIndex(item => item.step === props?.signer?.completed_signer_signature_step)
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        {fetchedData?.signature_settings?.steps?.map((step, index) => (
                        <ThemeProvider key={`${index}-${step.step}-${props.signer?.signer_key}`} theme={theme}>
                            <Tooltip key={step.step} title={stepMapper[step.step]}>
                                <Box
                                    sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    backgroundColor: index <= activeIndex ? '#1976d2' : '#cfd8dc',
                                    transition: 'background-color 0.3s',
                                    cursor: 'default',
                                    }}
                                />
                            </Tooltip>
                        </ThemeProvider>
                        ))}
                    </Box>
                );       
            } else {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        {fetchedData?.signature_settings?.steps?.map((step, index) => (
                        <ThemeProvider key={`${index}-${step.step}`} theme={theme}>
                            <Tooltip key={step.step} title={stepMapper[step.step]}>
                                <Box
                                    sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    backgroundColor: '#cfd8dc',
                                    transition: 'background-color 0.3s',
                                    cursor: 'default',
                                    }}
                                />
                            </Tooltip>
                        </ThemeProvider>
                        ))}
                    </Box>
                );       
            } 
            
        }
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    } else if (error.hasError) {
        return (
            <ErrorPage />
        )
    } else if (fetchedData) {
        return (
            <div className="page-container">
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <ErrorBoundary>
                    <header className="gap--5">
                        <h1>
                            {`Envelope ${fetchedData.subject}`}
                        </h1>
                        <h2>
                            <span>ID do Envelope: </span>
                            <span id="not-bold">{fetchedData.id}</span>
                        </h2>
                    </header>
                </ErrorBoundary>
                <div style={{display: 'flex', justifyContent:'center'}}>
                    {(userRoles.includes("create_envelopes"))
                    && (["created"].includes(fetchedData.status)) && (
                    <div style={{marginRight:"12px"}}>
                        <BaseButton
                            label="ENVIAR ENVELOPE"
                            className="btn__container--center btn btn--green btn--animated"
                            onClick={() => submitEnvelope(envelopeKey)}
                        >
                            {envelopeLoading ?
                                <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                :
                            <ThumbUpAltIcon style={{ width: "1.8rem", height: "1.8rem" }}/>}
                        </BaseButton>
                    </div>
                    )}
                    {(userRoles.includes("cancel_envelope"))
                        && (["on_signature", "submitted", "created"].includes(fetchedData.status)) && (
                        <div style={{marginRight:"12px"}}>
                            <BaseButton
                                label="CANCELAR ENVELOPE"
                                className="btn__container--center btn btn--red btn--animated"
                                onClick={() => setCancelDialogOpen(true)}
                            >
                                {envelopeLoading ?
                                    <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                    :
                                <CancelRoundedIcon style={{ width: "1.8rem", height: "1.8rem" }}/>}
                            </BaseButton>
                        </div>
                        )}
                </div>
                <ul className="inbox">
                    <li className="inbox__header">
                        <div className="inbox__cell--left">Documentos</div>
                    </li>
                    <li className="inbox__body" style={{display: "flex", alignItems:  "center", justifyContent: "center", marginBottom: "24px"}}>
                        <div className="inbox__cell--column-container inbox__cell--gap-2">
                            {
                                (fetchedData.documents || [])?.length > 0 
                                &&
                                <>
                                    {fetchedData.status === 'completed' 
                                    && userRoles.includes("load_envelope_report") 
                                    && (fetchedData.documents || [])?.length > 1  &&
                                        <div key={document.document_key} className="inbox__cell--row-container" style={{ gap:"16px"}}>
                                            <BaseButton
                                                    label="BAIXAR TODOS COMPROVANTES DE ASSINATURA"
                                                    onClick={() => downloadZip()}
                                                    className="btn__container--center btn btn--white btn--animated"
                                                    isDisabled={zipLoading || fetchedData.status !== "completed"}
                                                >
                                                    {zipLoading ?
                                                        <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                        :
                                                        <FolderZipIcon style={{ width: "1.8rem", height: "1.8rem" }} />}
                                                </BaseButton>
                                        </div>
                                    }
                                    {fetchedData.documents.map((document, index) => (
                                    <div key={document.document_key} className="inbox__cell--row-container" style={{ gap:"16px"}}>
                                        <ErrorBoundary>
                                            <BaseAvatar value={index + 1} />
                                            <div className="inbox__cell--column-container" style={{flex: 1}}>
                                                <p key={document.document_key}>{document.name}</p>
                                                <DataField
                                                    label="ID do Documento"
                                                    field={document.id}
                                                />
                                            </div>
                                        </ErrorBoundary>
                                        <div>
                                            <BaseButton
                                                label="VISUALIZAR DOCUMENTO"
                                                onClick={() => handleDocumentKey(document.document_key)}
                                                className="btn__container--center btn btn--white btn--animated"
                                                isDisabled={documentFileLoading && document.document_key === documentKey}
                                                    >
                                                {(documentFileLoading && document.document_key === documentKey) ?
                                                    <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                                :
                                                <FindInPageIcon 
                                                    style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                                                />}
                                            </BaseButton>
                                        </div>
                                        {userRoles.includes("load_envelope_report") && (
                                            <div>
                                                <BaseButton
                                                        label="COMPROVANTE DE ASSINATURA"
                                                        onClick={() => downloadReport(document.document_key, index)}
                                                        className="btn__container--center btn btn--white btn--animated"
                                                        isDisabled={reportLoading[index] || fetchedData.status !== "completed"}
                                                    >
                                                        {reportLoading[index] ?
                                                            <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                            :
                                                            <DownloadIcon style={{ width: "1.8rem", height: "1.8rem" }} />}
                                                    </BaseButton>
                                            </div>
                                        )}
                                        {
                                            userRoles.includes('delete_documents') &&
                                            (
                                                <div>
                                                    <BaseButton
                                                            label="REMOVER DOCUMENTO"
                                                            onClick={() => deleteDocument(document.document_key, index)}
                                                            className="btn__container--center btn btn--white btn--animated"
                                                            isDisabled={
                                                                documentRemovalLoading[index] ||
                                                                !(['created', 'submitted', 'on_signature'].includes(fetchedData.status) && canManageDocuments)
                                                            }
                                                        >
                                                            {documentRemovalLoading[index] ?
                                                                <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                                :
                                                                <DeleteIcon style={{ width: "1.8rem", height: "1.8rem" }} />}
                                                        </BaseButton>
                                                </div>
                                            )
                                        }
                                    </div>
                                    )) }        
                                </>                      

                            }
                            {
                                (['created', 'submitted', 'on_signature'].includes(fetchedData.status) && canManageDocuments) &&
                                <div>
                                    <hr></hr>
                                    <div style={{marginTop: "20px"}}>
                                        <Dropzone setter={handleAttachDocument} unsetter={handleRemoveDocument} files={attachedDocuments} handleToast={handleToast}/>
                                    </div>  
                                    {
                                        attachedDocuments.length > 0 &&
                                        <div style={{display: 'flex', padding: "10px 60px"}}>
                                            <BaseButton
                                                label="Anexar"
                                                onClick={() => handleAttacheDocumentsSubmission(envelopeKey)}
                                                className="btn__container--center btn btn--white btn--animated"
                                            >
                                                {
                                                    attachDocumentsLoading ? <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                    : <DownloadIcon style={{ width: "1.8rem", height: "1.8rem" }} />
                                                }

                                            </BaseButton>
                                            <BaseButton
                                                label="Cancelar"
                                                onClick={() => resetDocuments()}
                                                className="btn__container--center btn btn--white btn--animated"
                                            >
                                                <CancelRoundedIcon style={{ width: "1.8rem", height: "1.8rem" }}/>
                                            </BaseButton>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </li>
                </ul>
                {
                    (fetchedData.status === 'in_manual_analysis' || fetchedData.status === 'waiting_for_rule_analysis') &&
                    fetchedData.rule_analysis_status === 'in_manual_analysis' &&
                    userRoles.includes("approve_envelope_rule_analysis") &&
                    <ul className="inbox">
                        <li className="inbox__header">
                            <div className="inbox__cell--left">Aprovação de assinaturas</div>
                        </li>
                        <li className="inbox__body" style={{display: "flex", alignItems:  "center", justifyContent: "center", marginBottom: "24px"}}>
                            <div className="inbox__cell--column-container inbox__cell--gap-2">
                                <p style={{marginTop: '20px'}}>Depois de analisar os dados dos assinantes, decida se a assinatura do envelope deve ser aprovada</p>
                                
                                <div key={document.document_key} className="inbox__cell--row-container" style={{ gap:"16px", margin:"0 auto"}}>
                                    
                                {
                                    envelopeRuleAnalysisLoading ?
                                    <>
                                        <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                    </>
                                    : <>
                                        <div>
                                        <BaseButton
                                            label="APROVAR"
                                            onClick={() => updateEnvelopeRuleAnalysisStatus('approved')}
                                            className="btn__container--center btn btn--white btn--animated"
                                            isDisabled={false}
                                                >
                                            {(documentFileLoading && document.document_key === documentKey) ?
                                                <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                            :
                                            <AssignmentTurnedInIcon 
                                                style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                                            />}
                                        </BaseButton>
                                    </div>
                                    <div>
                                        <BaseButton
                                            label="REPROVAR"
                                            onClick={() => updateEnvelopeRuleAnalysisStatus('reproved')}
                                            className="btn__container--center btn btn--white btn--animated"
                                            isDisabled={false}
                                                >
                                            {(documentFileLoading && document.document_key === documentKey) ?
                                                <img className="btn__icon" src={LoadingIcon} alt="Loading" />
                                                            :
                                            <CancelIcon 
                                                style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                                            />}
                                        </BaseButton>
                                    </div>
                                    </>
                                }
                                    
                               </div> 
                            </div>
                        </li>
                    </ul>
                }
                {
                    ['approved', 'reproved'].includes(fetchedData.rule_analysis_status) &&
                    userRoles.includes("approve_envelope_rule_analysis") &&
                    <ul className="inbox">
                        <li className="inbox__header">
                            <div className="inbox__cell--left">Aprovação de assinaturas</div>
                        </li>
                        <li className="inbox__body" style={{display: "flex", alignItems:  "center", justifyContent: "center", marginBottom: "24px"}}>
                            <div className="inbox__cell--column-container inbox__cell--gap-2">
                                <p style={{margin: '20px auto'}}>
                                    {
                                    fetchedData.rule_analysis_status === 'approved' ? <span style={{color: "green"}}><b>APROVADO</b></span>
                                    : fetchedData.rule_analysis_status === 'reproved'? <span style={{color: "red"}}><b>REPROVADO</b></span>
                                    : 'Não foi possível obter informação do envelope'
                                    }
                                </p>
                            </div>
                        </li>
                    </ul>
                }
                {
                    (userRoles.includes('manage_signers') && 
                    (["on_signature", "submitted", "created"].includes(fetchedData.status))) &&
                    <ul className="inbox">
                        <div className="inbox__cell--center">
                            <BaseButton
                                label="ADICIONAR ASSINANTE"
                                onClick={() => {
                                    setOpenSignerCreationDialog(true)
                                }}
                                className="btn__container--center btn btn--white btn--animated">
                                <PersonAddAltIcon 
                                    style={{ width: "16px", height: "16px", cursor: "pointer" }} 
                                />
                            </BaseButton>
                        </div>
                    </ul>
                }

                <ul className="inbox">
                    <li className="inbox__header">
                        <div className="inbox__cell--left">Assinantes:</div>
                        <div className="inbox__cell--center">Dados dos Assinantes:</div>
                        <div className="inbox__cell--center">Etapas</div>
                        <div className="inbox__cell--center">Assinado em:</div>
                        <div className="inbox__cell--center">Ações:</div>
                        <div className="inbox__cell--right">Status:</div>
                    </li>
                    {fetchedData.signers.filter(signer => !signer.deactivated_on).map((signer) => (
                        <li key={signer.signer_key} className="inbox__body">
                            <ErrorBoundary>
                                <div className="inbox__cell--left">
                                    {['on_signature', 'submitted', 'created'].includes(signer.status) && userRoles.includes("manage_signers") ?
                                        <>
                                            <div  style={{cursor: 'pointer', border: '1px solid #0b1f82', color: '#0b1f82', padding: '8px', borderRadius: '4px', marginLeft: '8px'}} 
                                                onClick={() => {
                                                    if(!['on_signature', 'submitted', 'created'].includes(fetchedData.status)){
                                                        return handleToast('Não é possível alterar dados de assinante quando o envelope já iniciou processo de assinatura.', 'error')    

                                                    }
                                                    setSignerChangeDialogOpen(signer.signer_key)
                                                }}
                                            >
                                                Modificar assinante
                                            </div>
                                            <Dialog open={signerChangeDialogOpen === signer.signer_key}>
                                                <LegacySignerChangeDialog 
                                                    signer={signer} 
                                                    envelope={fetchedData}
                                                    onClose={() => {
                                                        setSignerChangeDialogOpen('')
                                                        setRefresh(!refresh)
                                                    }} 
                                                    handleToast={handleToast}
                                                />
                                            </Dialog>
                                        </> : <></>
                                    }
                                </div>
                                <div className="inbox__cell--left inbox__cell--row-container">
                                    {userRoles.includes("manage_signers")
                                        && (["on_signature", "submitted", "created"].includes(signer.status)) ?
                                        <button
                                            className="btn btn--white btn--animated"
                                            onClick={() => editSignerDataHandler(signer.signer_key)}
                                        >
                                            <EditNoteIcon id={signer.signer_key} style={{ width: "1.8rem" }} />
                                        </button>
                                        : <div className="envelope__signer-cell-btn--width"></div>}
                                    <div className="envelope__signer-cell--width inbox__cell--column-container">
                                        {signer.document_number &&
                                            <DataField
                                                label="Documento"
                                                field={signer.document_number}
                                            />}
                                        {signer.birthdate &&
                                            <DataField
                                                label="Data de Nascimento"
                                                field={formatBirthdateToFront(signer.birthdate)}
                                            />}
                                        {signer.name &&
                                            <DataField
                                                label="Nome do assinante"
                                                field={signer.name}
                                            />}
                                        {signer.email &&
                                            <DataField
                                                label="Email"
                                                field={signer.email}
                                            />}
                                        {signer.phone &&
                                            <DataField
                                                label="Telefone"
                                                field={`${signer.phone.international_dial_code} (${signer.phone.area_code}) ${signer.phone.number.slice(0, 5)}-${signer.phone.number.slice(5, 9)}`}
                                            />} 
                                        {signer.signature_role ?
                                            <DataField
                                                label="Papel de assinatura"
                                                field={translateSignatureRole(signer.signature_role)}
                                            /> : <></>
                                        }
                                    </div> 
                                </div>
                                {
                                    <div className="inbox__cell--center inbox__cell--row-container">
                                        <CustomStepper signer={signer}/>
                                    </div>
                                }
                                {signer.signed_at ?
                                    <div className="inbox__cell--center">
                                        <DatetimeBlock dateString={signer.signed_at} />
                                    </div>
                                    : <div className="envelope__date-time--height inbox__cell--center"></div>}
                                    <div className="inbox__cell--center inbox__cell--row-container">
                                    {userRoles.includes("renotify_signer") && (signer.status === "on_signature") &&
                                            <ThemeProvider theme={theme}>
                                                <Tooltip title="Reenviar notificação de assinatura" placement="top">
                                                    <button className="btn btn--animated btn--white" onClick={() => !notificationLoading ? resendNotification(signer.signer_key) : null}>
                                                        {(notificationLoading&&notificationSignerKey===signer.signer_key)?
                                                        <CircularProgress style={{ color: "#2d2d2d" }} size={"1.6rem"} />
                                                        :
                                                            (signer.document_submission_method==="sms")?
                                                                <SendToMobileOutlinedIcon style={{ width: "1.8rem", color: "#525252" }} />
                                                                :<SendEmailIcon style={{ width: "1.8rem", color: "#525252" }} />
                                                        }
                                                    </button>
                                                </Tooltip>
                                            </ThemeProvider>
                                        }
                                        <ThemeProvider theme={theme}>
                                            <Tooltip title="Copiar link de assinatura" placement="top">
                                                <button className="btn btn--animated btn--white" onClick={() => copySignerSignatureUrl(signer.signer_key)}>
                                                    <ContentCopyIcon style={{ width: "1.8rem", color: "#525252" }} />
                                                </button>
                                            </Tooltip>
                                        </ThemeProvider>
                                        {
                                            <ThemeProvider theme={theme}>
                                                <Tooltip title="Verificar dados de assinatura" placement="top">
                                                    <button className="btn btn--animated btn--white" onClick={() => viewSignerAnalysis(signer)}>
                                                        <AssignmentIcon style={{ width: "1.8rem", color: "#525252" }} />
                                                    </button>
                                                </Tooltip>
                                            </ThemeProvider>
                                        }
                                        {
                                            userRoles.includes("list_signer_notifications") && new Date(signer.created_at) > new Date('2025-07-24') &&
                                            <ThemeProvider theme={theme}>
                                                <Tooltip title="Ver histórico de notificação" placement="top">
                                                    <button className="btn btn--animated btn--white" onClick={() => viewSignerNotifications(signer)}>
                                                        <NotificationsNoneIcon style={{ width: "1.8rem", color: "#525252" }} />
                                                    </button>
                                                </Tooltip>
                                            </ThemeProvider>
                                        }
                                        {
                                            userRoles.includes("manage_signers") && 
                                            (signer.status === "on_signature") &&
                                            ["created", "submitted", "on_signature"].includes(fetchedData.status) &&
                                            <ThemeProvider theme={theme}>
                                                <Tooltip title="Remover da lista de assinantes" placement="top">
                                                    <button className="btn btn--animated btn--white" onClick={() => removeSignerFromEnvelopeListDecision(signer.signer_key)}>
                                                        <DeleteIcon style={{ width: "1.8rem", backgroundColor: "#red" }} />
                                                    </button>
                                                </Tooltip>
                                            </ThemeProvider>
                                        }
                                    </div>
                                <div className="inbox__cell--right">
                                    <div className="inbox__cell--row-container">
                                        
                                        <StatusIconText
                                            status={signer.status}
                                            rule_analysis_status={signer.rule_analysis_status}
                                            type="signer_status"
                                        />
                                    </div>
                                </div>
                            </ErrorBoundary>
                        </li>
                    ))}
                </ul>

                <SignerCreationDialog
                    open={openSignerCreationDialog}
                    setOpen={setOpenSignerCreationDialog}
                    handleToast={handleToast}
                    envelopeData={fetchedData}
                />

                <SignerRemoveDecisionDialog
                    open={openSignerRemovedDialog} 
                    setOpen={setOpenSignerRemovedDialog}
                    selectedRemoveSigner={selectedRemoveSigner}
                    handleSubmit={() => removeSignerFromEnvelopeList(selectedRemoveSigner)}
                    envelopeData={fetchedData}
                />

                {documentFile && (
                    <>
                        <MuiDialog 
                        open={openFileDialog}
                        onClose={() => handleCloseFileDialog()}
                        >
                            <PDFContent 
                                pdfFile={documentFile.document_file} 
                            />
                        </MuiDialog>
                    </>
                )}
                {signerKey && signerName && dialogFields && (userRoles.includes("update_signer_data") || userRoles.includes("manage_signers" )) &&
                <SignerDataDialog
                    open={editSignerDataDialogOpen}
                    setOpen={setEditSignerDataDialogOpen}
                    signerKey={signerKey}
                    setSignerKey={setSignerKey}
                    signerName={signerName}
                    setSignerName={setSignerName}
                    fetchEnvelopeData={fetchEnvelopeData}
                    values={dialogValues}
                    setValues={setDialogValues}
                    fields={dialogFields}
                />}
                {
                    signerAnalyzing && signerAnalysisDialogOpen &&
                    <SignerAnalysisDataDialog
                        open={signerAnalysisDialogOpen}
                        setOpen={setSignerAnalysisDialogOpen}
                        signerAnalyzing={signerAnalyzing}
                        setSignerAnalyzing={setSignerAnalyzing}
                    />
                }
                {
                    signerNotificationsSelected && signerNotificationsDialogOpen &&
                    <SignerNotificationsTimeLineDialog
                        open={signerNotificationsDialogOpen}
                        setOpen={setSignerNotificationsDialogOpen}
                        signerNotificationsSelected={signerNotificationsSelected}
                        setSignerNotificationsSelected={setSignerNotificationsSelected}
                    />
                }
                <NotificationDialog
                    open={notificationDialogOpen}
                    setOpen={setNotificationDialogOpen}
                    notificationError={notificationError}
                    setNotificationError={setNotificationError}
                />
                <ReportErrorDialog
                    reportError={reportError}
                    setReportError={setReportError}
                />
                <DeleteDocumentErrorDialog
                    deleteDocumentError={deleteDocumentError}
                    setDeleteDocumentError={setDeleteDocumentError}
                />
                <ZipErrorDialog
                    zipError={zipError}
                    setZipError={setZipError}
                />
                <CancelEnvelopeErrorDialog
                    cancelEnvelopeError={cancelEnvelopeError}
                    setCancelEnvelopeError={setCancelEnvelopeError}
                />
                <CancelEnvelopeDecisionDialog
                    open={cancelDialogOpen} 
                    setOpen={setCancelDialogOpen}
                    handleCancel={() => cancelEnvelope(envelopeKey)}    
                />
                <SubmitEnvelopeErrorDialog
                    submitEnvelopeError={submitEnvelopeError}
                    setSubmitEnvelopeError={setSubmitEnvelopeError}
                />
            </div>
        )
    }
}

const Dropzone = (props) => {
    const { setter, unsetter, files, handleToast } = props;

    const fileHandler = (acceptedFiles) => {
        const acceptedFilesList = [...acceptedFiles]
        const pdfFiles = acceptedFilesList.filter(file => file.type === 'application/pdf');
        const notPdfFiles = acceptedFilesList.filter(file => file.type !== 'application/pdf')
        if( notPdfFiles.length > 0 )
            handleToast('Apenas são aceitos arquivos em formato PDF', 'warning')

        setter({
            target: {
                files: pdfFiles
            }
        });
    }
    
    // eslint-disable-next-line
    const onDrop = useCallback(fileHandler, [files]);

    const removeFile = (fileId, event) => {
        event.stopPropagation();
        event.preventDefault();
        unsetter(fileId)
    };

    const { getRootProps, getInputProps } = useDropzone({ 
        onDrop, 
        accept: 'application/pdf'
    });

    return (
        <S.Dropzone {...getRootProps()} style={{ padding: '20px', border: '2px dashed gray' }}>
            <input {...getInputProps()} onChange={(e) => fileHandler(e.target.files)}/>
            <p style={(props.files || []).length > 0 ? { margin: "0 0 8px 0", fontWeight: 'bold' } : { margin: 0, fontWeight: 'bold' }}>
                Arraste os anexos PDF desejados
            </p>
            <ul style={{ width: '100%' }}>
                {(props.files || []).map((file, index) => (
                    <li 
                        key={index} 
                        style={{ marginBottom: "4px", fontSize: "12px", display: 'flex', flexDirection: 'row', width: "100%", justifyContent: 'space-between', alignItems: 'center' }}>
                        {file.name}
                        <button 
                            style={{ display: 'flex', width: '24px', height: '24px', backgroundColor: "#00000000", alignItems: 'center', justifyContent: 'center', border: 'none', outline: 'none' }} 
                            onClick={(event) => {
                                removeFile(file.id, event)}}
                        >
                            <TrashIcon style={{color: 'red'}}/>
                        </button>
                    </li>
                ))}
            </ul>
        </S.Dropzone>
    );
};